module.exports = __webpack_public_path__ + "static/img/AR@3x.8538b3f3.jpg";